import React, { Component } from 'react';
import PropTypes from 'prop-types';

import services from '../../services/services';
import { Row } from 'react-materialize';
import Button from '@material-ui/core/Button';
import { OverlaiedLoader, MiniLoader } from '../Loader';

import { allNotifications } from '../../utils/toastify';

import './index.scss';

const { notifyErrorBottomRight } = allNotifications;

class NewProcedure extends Component {
  state = {
    description: '',
    isLoadingProcedures: true,
    flagDenteObrig: true,
    flagFaceObrig: true,
    flagRegiaoObrig: true,
    selectedProcedure: {},
    selectedFace: '',
    selectedTooth: '',
    selectedRegion: '',
    proceduresList: [],
    toothHolder: '',
    toothRegionList: [],
    listRegion: [],
    faceHolder: '',
    facesPermit: [],
    isDisabled: true,
    isFocused: false,
    faceDisable: false,
    denteDisable: false,
    regionDisable: false,
    showProcedureError: false,
    procedureLabelClassName: ''
  };

  componentDidMount() {
    const { procedure } = this.props;
    if (procedure) {
      this.onSelectDefaultProcedure(procedure);

      this.setState({
        faceDisable: !procedure.flagFaceObrig || procedure.facesPermit.length === 0,
        denteDisable: !procedure.flagDenteObrig || procedure.toothRegionList.length === 0,
        regionDisable: !procedure.flagRegiaoObrig || procedure.listRegion.length === 0
      });
    }
  }

  loadProcedures = value =>
    services
      .procedimento('getProceduresTypesWithToken', value)
      .then(res => this.setState({ proceduresList: res, showProcedureError: false }))
      .catch(() => {
        this.setState({ showProcedureError: true, proceduresList: [] });
      })
      .then(() => this.setState({ isLoadingProcedures: false }));

  handleChange = async (e, key) => {
    await this.setState({ [key]: e.target.value }, () => this.shouldEnableBtn());

    const { flagFaceObrig, flagRegiaoObrig } = this.state;

    if (key === 'selectedTooth' && (flagFaceObrig || flagRegiaoObrig)) {
      this.setState({ facesPermit: [] }, () => this.loadFaces(e, key));
    }
  };

  loadFaces = () => {
    const { procedure } = this.props;

    services
      .procedimento('validateProc', {
        procedureId: procedure ? procedure.codigo : this.state.selectedProcedure.codigo.trim(),
        tooth: this.state.selectedTooth
      })
      .then(res => {
        const newFaces = this.sortlist(res.listaDetalheProcedimentoModels.facesPermit);
        const newRegion = this.sortlist(res.listaDetalheProcedimentoModels.listaRegiao);

        this.setState(
          {
            selectedFace: newFaces.length > 0 && newFaces[0] !== '' ? newFaces[0] : '',
            facesPermit: newFaces,
            listRegion: newRegion,
            faceDisable: newFaces.length === 0,
            regionDisable: newRegion.length === 0
          },
          () => this.shouldEnableBtn()
        );
      })
      .catch(err => {
        this.notify(err.message);
        this.setState({ isDisabled: false });
      });
  };

  notify = message => notifyErrorBottomRight(message);

  handleInputProcedures = e => {
    const limitToSearch = 5;
    const { value } = e.target;

    const isSmaller = value.length < limitToSearch;
    const hasValue = value.length > 0

    this.setState({ procedureLabelClassName: hasValue ? 'active' : '' });

    this.setState({ showProcedureError: false });

    this.setState(
      {
        description: value,
        facesPermit: [],
        toothRegionList: [],
        listRegion: [],
        isLoadingProcedures: !isSmaller
      },
      () => {
        if (isSmaller) {
          this.setState({ proceduresList: [] });
        } else {
          // Caso seja número deve trazer tudo para depois filtrar a lista
          if (Number.isNaN(value)) {
            this.loadProcedures(value);
          } else {
            this.loadProcedures();
          }

          this.setState({ isFocused: !!this.state.description.length });
        }
      }
    );
  };

  handleBlur = () => setTimeout(() => this.setState({ isFocused: false }), 700);

  shouldEnableBtn = () => {
    const {
      flagFaceObrig,
      flagDenteObrig,
      flagRegiaoObrig,
      selectedFace,
      selectedTooth,
      selectedRegion,
      toothRegionList
    } = this.state;

    const canAllowByFace = !(flagFaceObrig && selectedFace.length === 0);
    const canAllowByTooth = !(
      flagDenteObrig &&
      selectedTooth.length === 0 &&
      toothRegionList.length > 0
    );
    const canAllowByRegion = !(flagRegiaoObrig && selectedRegion.length === 0);

    const isEditable = canAllowByFace && canAllowByTooth && canAllowByRegion;

    this.setState({ isDisabled: !isEditable });
  };

  sortlist = list => {
    if (list === undefined || list.length === 0) {
      return [];
    }

    let sortedList = [];

    if (list.indexOf('^') !== -1) {
      sortedList = list.split('^').sort();
      if (sortedList[0] !== '') {
        sortedList.unshift('');
      }
    } else if (list.indexOf(',') !== -1) {
      sortedList = list
        .replace(/\s/g, '')
        .split(',')
        .sort();
      if (sortedList[0] !== '') {
        sortedList.unshift('');
      }
    } else {
      sortedList.push(list);
      if (sortedList[0] !== '') {
        sortedList.unshift('');
      }
    }
    return sortedList;
  };

  onSelectDefaultProcedure = procedure => {
    this.setState(
      {
        description: procedure.descricao,
        selectedProcedure: procedure,
        facesPermit: procedure.facesPermit,
        toothRegionList: procedure.toothRegionList,
        listRegion: procedure.listRegion,
        flagDenteObrig: procedure.flagDenteObrig,
        flagFaceObrig: procedure.flagFaceObrig,
        flagRegiaoObrig: procedure.flagRegiaoObrig,
        selectedTooth: procedure.tooth,
        selectedFace: procedure.face,
        selectedRegion: procedure.region
      },
      () => this.shouldEnableBtn()
    );
  };

  onSelectProcedure = async value => {
    this.setState({ showOverlayLoading: true });

    const isoFaceToothRegion = await services.procedimento('validateProc', {
      procedureId: value.codigo.trim(),
      tooth: ''
    });

    const newTeeth = await this.sortlist(
      isoFaceToothRegion.listaDetalheProcedimentoModels.dentesPermit
    );
    const newRegion = await this.sortlist(
      isoFaceToothRegion.listaDetalheProcedimentoModels.listaRegiao
    );

    this.setState(
      {
        description: value.descricao,
        selectedProcedure: value,
        facesPermit: [],
        toothRegionList: newTeeth,
        listRegion: newRegion,
        flagDenteObrig: isoFaceToothRegion.listaDetalheProcedimentoModels.flagDenteObrig,
        flagFaceObrig: isoFaceToothRegion.listaDetalheProcedimentoModels.flagFaceObrig,
        flagRegiaoObrig: isoFaceToothRegion.listaDetalheProcedimentoModels.flagRegiao,
        isFocused: false,
        selectedTooth: '',
        selectedFace: '',
        selectedRegion: '',
        faceDisable: true,
        denteDisable: newTeeth.length === 0,
        regionDisable: newRegion.length === 0,
        showProcedureError: false,
        showOverlayLoading: false
      },
      () => this.shouldEnableBtn()
    );

    this.verificarProcedimentosEsteticos(value.codigo.trim());
  };

  verificarProcedimentosEsteticos = codigo => {
    const procedimentosEsteticos = ['85400106', '85100064', '85400238', '85100170', '85400548', '85400530', '85400513', '85400521', '85400181'];

    if (procedimentosEsteticos.includes(codigo)) {
      notifyErrorBottomRight('IMPORTANTE:                     Tratamentos clínicos para fins exclusivamente estéticos não fazem parte da cobertura contratual e não devem ser solicitados. Caso prossiga a SulAmérica poderá rever a autorização posteriormente.');
    }
  }

  verificarAcaoDentistica = async codigo => {
    const { codigoPrestador, updatedPlans } = this.props;
    const codBenef = updatedPlans?.numero_carteirinha;
    const codPrest = codigoPrestador || localStorage.getItem('codDentista');
    let contrato = updatedPlans?.numero_contrato || updatedPlans?.contrato || 0;

    if (!codBenef || !codPrest) {
      return null;
    }

    if (!contrato) {
      try {
        const responseContrato = await services.beneficiario('getContractNumber', codBenef);
        contrato = responseContrato?.contrato || 0;
      } catch (e) {
        return null;
      }
    }

    try {
      const responseElegibilidade = await services.beneficiario('getElegibility', {
        codBenef,
        contrato,
        codPrest,
        codServico: codigo
      });

      const acaoDentistica =
        Array.isArray(responseElegibilidade?.acaoDentistica) &&
        responseElegibilidade.acaoDentistica.length > 0
          ? responseElegibilidade.acaoDentistica[0]
          : null;

      if (acaoDentistica?.dscMensagemAcao) {
        notifyErrorBottomRight(acaoDentistica.dscMensagemAcao);
      }

      return acaoDentistica;
    } catch (e) {
      // silencioso: não bloqueia inclusão do procedimento
    }

    return null;
  };

  create = async () => {
    this.setState({ isDisabled: true });
    const {
      selectedProcedure,
      selectedTooth,
      selectedFace,
      selectedRegion,
      facesPermit,
      toothRegionList,
      listRegion,
      flagDenteObrig,
      flagFaceObrig,
      flagRegiaoObrig
    } = this.state;
    const { codigo, descricao } = selectedProcedure;

    const procedure = {
      id: `_${Math.random()
        .toString(36)
        .substr(2, 9)}`,
      codigo: codigo.trim(),
      descricao,
      face: selectedFace,
      tooth: selectedTooth,
      region: selectedRegion,
      facesPermit,
      toothRegionList,
      listRegion,
      flagDenteObrig,
      flagFaceObrig,
      flagRegiaoObrig
    };

    const acaoDentistica = await this.verificarAcaoDentistica(codigo.trim());
    if (acaoDentistica) {
      procedure.acaoDentistica = [acaoDentistica];
      procedure.flg_foto_inicial = acaoDentistica.flgFotoInicial === 'S';
      procedure.flg_foto_final = acaoDentistica.flgFotoFinal === 'S';
    }

    this.props.addProcedure(procedure);
  };

  update = () => {
    this.setState({ isDisabled: true });
    const { selectedTooth, selectedFace, selectedRegion } = this.state;

    const { procedure } = this.props;
    const copy = Object.assign({}, procedure);

    copy.face = selectedFace;
    copy.tooth = selectedTooth;
    copy.region = selectedRegion;

    this.props.editProcedure(copy);
  };

  render() {
    const { showProcedureError } = this.state;
    const { procedure } = this.props;

    const {
      selectedTooth,
      selectedFace,
      selectedRegion,
      facesPermit,
      toothRegionList,
      listRegion,
      toothHolder,
      faceHolder,
      isFocused,
      description,
      proceduresList,
      faceDisable,
      denteDisable,
      regionDisable,
      procedureLabelClassName
    } = this.state;

    return (
      <div className="NewProcedure">
        <div className="NewProcedure__infos row">
          <Row>
            <form
              className="col s12"
              style={{
                padding: '0px 0px 52px 0px',
                marginBottom: '-35px',
                backgroundColor: '#FFFFFF'
              }}
              onSubmit={e => e.preventDefault()}
            >
              {/** INPUT DE PROCEDIMENTOS */}
              <Row className="procedures">
                <div className="col input-field s12">
                  <input
                    type="text"
                    id="input_proc"
                    autoComplete="off"
                    value={procedure ? procedure.descricao : description}
                    className="autocomplete"
                    // onBlur={() => setTimeout(() => this.setState({ isFocused: false }), 700)}
                    onBlur={this.handleBlur}
                    onChange={this.handleInputProcedures}
                    disabled={!!procedure}
                  />
                  <label className={procedureLabelClassName} htmlFor="input_proc">
                    Procedimentos
                    {/* {showProcedureError && (
                      <span>
                        <small className="labelInvalid"> Procedimento inválido </small>
                      </span>
                    )} */}
                  </label>
                  <ul
                    className="autocomplete-content dropdown-content"
                    style={isFocused ? { display: 'block' } : { display: 'none' }}
                  >
                    {!this.state.isLoadingProcedures &&
                      proceduresList
                        .filter(
                          item =>
                            item.descricao.toUpperCase().indexOf(description.toUpperCase()) !== -1
                        )
                        .map(item => (
                          <li key={item.codigo} onClick={() => this.onSelectProcedure(item)}>
                            <span>{item.descricao}</span>
                          </li>
                        ))}
                    {this.state.isLoadingProcedures && (
                      <li className="listLoader">
                        <MiniLoader />
                      </li>
                    )}
                  </ul>
                </div>
              </Row>

              {/** INPUT DE DENTE */}
              <div className="dropdown-select">
                <label>
                  Dente
                  <select
                    style={denteDisable ? { display: 'none' } : { display: 'block' }}
                    value={selectedTooth}
                    onChange={e => this.handleChange(e, 'selectedTooth')}
                  >
                    {toothRegionList.length > 0 ? (
                      toothRegionList.map(item => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))
                    ) : (
                      <option>{toothHolder}</option>
                    )}
                  </select>
                  <input
                    style={!denteDisable ? { display: 'none' } : { display: 'block' }}
                    type="text"
                    value="Não possui seleção de Dente"
                    disabled
                  />
                </label>
              </div>

              {/** INPUT DE REGIÃO */}
              <div className="dropdown-select">
                <label>
                  Região
                  <select
                    style={regionDisable ? { display: 'none' } : { display: 'block' }}
                    value={selectedRegion}
                    onChange={e => this.handleChange(e, 'selectedRegion')}
                  >
                    {listRegion.length > 0 ? (
                      listRegion.map(item => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))
                    ) : (
                      <option>{toothHolder}</option>
                    )}
                  </select>
                  <input
                    style={!regionDisable ? { display: 'none' } : { display: 'block' }}
                    type="text"
                    value="Não possui seleção de Região"
                    disabled
                  />
                </label>
              </div>

              {/** INPUT DE FACES */}
              <div className="dropdown-select">
                <label>
                  Face
                  <select
                    style={faceDisable ? { display: 'none' } : { display: 'block' }}
                    value={selectedFace}
                    placeholder={faceHolder}
                    onChange={e => this.handleChange(e, 'selectedFace')}
                  >
                    {facesPermit.length > 0 ? (
                      facesPermit.map(item => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))
                    ) : (
                      <option>{faceHolder}</option>
                    )}
                  </select>
                  <input
                    style={!faceDisable ? { display: 'none' } : { display: 'block' }}
                    type="text"
                    value="Não possui seleção de Face"
                    disabled
                  />
                </label>
              </div>

              {/** BOTÃO SUBMIT */}

              <div className="btn-orange-container">
                <Button
                  onClick={procedure ? this.update : this.create}
                  disabled={this.state.isDisabled}
                  className="btn-orange col s12"
                  color="primary"
                  variant="contained"
                  disableElevation
                >
                  {procedure ? 'Salvar edição' : 'Incluir procedimento'}
                </Button>
              </div>
            </form>
          </Row>
        </div>

        {this.state.showOverlayLoading && <OverlaiedLoader />}
      </div>
    );
  }
}

NewProcedure.defaultProps = {
  procedure: null,
  updatedPlans: null,
  codigoPrestador: null
};

NewProcedure.propTypes = {
  procedure: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      codigo: PropTypes.number.isRequired,
      descricao: PropTypes.string.isRequired,
      face: PropTypes.string.isRequired,
      tooth: PropTypes.string.isRequired,
      region: PropTypes.string.isRequired
    })
  ),
  addProcedure: PropTypes.func.isRequired,
  updatedPlans: PropTypes.objectOf(PropTypes.any),
  codigoPrestador: PropTypes.number
};

export default NewProcedure;
